import React, { useEffect } from 'react';
import { Route } from 'react-router';

import { FreecodeContextProvider } from 'components/FreecodeContextProvider/FreecodeContextProvider';
import { manageZendeskButton } from 'functions/zendesk';

export default function FreecodeRoute({ component: Component, ...rest }) {
  useEffect(() => manageZendeskButton('hide'), []);

  const renderPage = (props) => (
    <FreecodeContextProvider>
      <Component {...props} />
    </FreecodeContextProvider>
  );

  return <Route {...rest} render={(props) => renderPage(props)} />;
}
